import useLazySelector from "common/redux/useLazySelector";
import PaymentOptionDetails from "domain/paymentOptionDetails";
import { loadMerchantPaymentOptions } from "./merchants.actions";
import { PaymentOption } from "domain/paymentOption";
import useStoreSelector from "common/redux/useStoreSelector";

export function usePaymentOptions(): PaymentOptionDetails[] {
    return useLazySelector(store => store.paymentOptionsDetails, dispatch => loadMerchantPaymentOptions(dispatch), null, []);
}

export function useAllowedPaymentOptions(allowedPaymentOptions?: PaymentOption[]): PaymentOptionDetails[] {
    const isCustomer = useStoreSelector(store => store.userState.isCustomer);
    const paymentOptionsDetails = usePaymentOptions();

    return paymentOptionsDetails?.filter(pod =>
        allowedPaymentOptions.includes(pod.paymentOption)
            && isCustomer ? pod.enabledForCustomers : pod.enabledForTraders);
}